import { useTranslation } from 'react-i18next';

interface WhatsAppBookingProps {
  accentColor?: string;
  serviceName?: string;
  serviceNameEn?: string;
}

const WhatsAppBooking = ({ accentColor = 'teal', serviceName, serviceNameEn }: WhatsAppBookingProps) => {
  const { t, i18n } = useTranslation('common');

  const whatsappNumber = '6593651286';

  const buildMessage = () => {
    if (i18n.language === 'zh') {
      return serviceName
        ? `你好，我想预约${serviceName}疗愈服务，请问有哪些时间可以安排？`
        : '你好，我想预约疗愈服务，请问有哪些时间可以安排？';
    }
    const name = serviceNameEn || serviceName || '';
    return name
      ? `Hello, I would like to book a ${name} session. What times are available?`
      : 'Hello, I would like to book a healing session. What times are available?';
  };

  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(buildMessage())}`;

  const colorMap: Record<string, { bg: string; text: string; border: string; light: string; icon: string }> = {
    amber: { bg: 'bg-amber-600', text: 'text-amber-600', border: 'border-amber-200', light: 'bg-amber-50', icon: 'text-amber-500' },
    emerald: { bg: 'bg-emerald-600', text: 'text-emerald-600', border: 'border-emerald-200', light: 'bg-emerald-50', icon: 'text-emerald-500' },
    rose: { bg: 'bg-rose-600', text: 'text-rose-600', border: 'border-rose-200', light: 'bg-rose-50', icon: 'text-rose-500' },
    teal: { bg: 'bg-teal-700', text: 'text-teal-700', border: 'border-teal-200', light: 'bg-teal-50', icon: 'text-teal-500' },
  };

  const c = colorMap[accentColor] ?? colorMap['teal'];

  return (
    <section id="booking" className="py-24 bg-stone-50">
      <div className="max-w-2xl mx-auto px-6 text-center">
        <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full ${c.light} mb-6`}>
          <i className={`ri-calendar-check-line text-3xl ${c.icon}`}></i>
        </div>
        <h2 className="text-4xl font-bold text-stone-800 mb-3">{t('whatsappBooking.title')}</h2>
        <p className="text-stone-500 text-base mb-12">{t('whatsappBooking.subtitle')}</p>

        <div className={`rounded-2xl border ${c.border} ${c.light} p-10 flex flex-col items-center gap-6`}>
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 flex items-center justify-center bg-[#25D366] rounded-full shadow-md">
              <i className="ri-whatsapp-line text-white text-2xl"></i>
            </div>
            <div className="text-left">
              <p className="text-xs text-stone-400 uppercase tracking-widest mb-0.5">{t('whatsappBooking.label')}</p>
              <p className={`text-2xl font-semibold ${c.text}`}>+65 9365 1286</p>
            </div>
          </div>

          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center justify-center gap-3 py-4 bg-[#25D366] hover:bg-[#1ebe5d] text-white rounded-full text-base font-semibold transition-all duration-300 hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-xl"></i>
            </div>
            {t('whatsappBooking.button')}
          </a>

          <p className="text-xs text-stone-400">{t('whatsappBooking.hint')}</p>
        </div>
      </div>
    </section>
  );
};

export default WhatsAppBooking;
